import { render, staticRenderFns } from "./inspectionTaskUpdateModal.vue?vue&type=template&id=54be0c36&scoped=true"
import script from "./inspectionTaskUpdateModal.vue?vue&type=script&lang=js"
export * from "./inspectionTaskUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./inspectionTaskUpdateModal.vue?vue&type=style&index=0&id=54be0c36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be0c36",
  null
  
)

export default component.exports